import React, { useState, useEffect } from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const TypingMessage = ({ message, onComplete }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < message.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + message[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 5); // 5ms per character

      return () => clearTimeout(timeout);
    } else if (currentIndex === message.length && onComplete) {
      // Small delay after typing completes before calling onComplete
      const completeTimeout = setTimeout(() => {
        onComplete();
      }, 200);
      return () => clearTimeout(completeTimeout);
    }
  }, [currentIndex, message, onComplete]);

  return (
    <div className="flex justify-start">
      <div className="max-w-[80%]">
        <p style={{ ...typography.medium.regular, color: colors.text.primary }}>
          {displayedText}
        </p>
      </div>
    </div>
  );
};

export default TypingMessage;
